// polish-len.mjs — 润色长度判定的**参考实现**（第一百一十六批，SB-143 ①）。
//
// ── 病灶：同一个 12，两个单位 ────────────────────────────────────────────────
// `defaults.h` 的注释写着「界面按同一条件禁用按钮；**两处都要有**（界面比接口窄或宽
// 都出过事，DP-2）」。而实现里两侧根本不是同一条件：
//
//   · 后端 `routes_me.cpp` 用 `trimmed.size()` —— **字节**（报错文案自己写着 "min 12 bytes"）；
//   · 前端 `pages/polish.mjs` 用 `t.length` —— **UTF-16 码元**。
//
// 后果今天就成立，且正是那句注释点名「都出过事」的两个方向：
//   · 4~11 个汉字（12~33 字节）：**前端灰着按不动，而接口收** —— 界面窄于接口；
//   · 100 个汉字的标题（300 字节）：**前端可按，按下去 400** —— 界面宽于接口。
//
// 还有**第三处**分歧，报告里没提而读代码时撞见的：后端只做**右截**
// （`find_last_not_of` 之后 substr），前端是 `.trim()` **两端都截**。
// 于是 `"   abc…"` 这类前导空格在两侧算出来的长度不同。
//
// ── 为什么单纯比数字的判据不够 ──────────────────────────────────────────────
// **今天两个数字都是 12**。一条比常量的判据会一路绿灯，而它要抓的是单位不同。
// 所以这里照本仓 md_render 的既有姿态办：**JS 为参考实现，生成向量，cpp 逐条比对**。
//
// ── 口径：Unicode 码位 ──────────────────────────────────────────────────────
// 取码位（不是 UTF-16 码元，也不是字节），理由：
//   · 用户看见的是「我打了几个字」，字节是实现细节；
//   · 码元会让一个 emoji 算两个，而用户看见的是一个；
//   · 码位在两侧都能**精确**实现（JS 用展开符，C++ 数非续接字节），
//     不需要任何库，也不会因 locale 而变。
// 已知不覆盖：组合字（é 分解形式算 2）与 ZWJ 家族 emoji。**刻意不处理**——
// 处理它需要 grapheme 分段，两侧各自实现必然漂开，而那正是本单要治的病。
// 这条限制写在这里，免得下一个人以为它已经被覆盖了。

// 两端截空白，与前端 `.trim()` 一致。**后端原本只截右侧，本批一并对齐。**
export function polishTrim(text) {
  return String(text ?? '').trim();
}

// 截空白之后的**码位**数。
export function polishLen(text) {
  return [...polishTrim(text)].length;
}
